if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('[data-header-bar]');
        this.burger = this.querySelector('[data-header-burger]');
        this.drawer = this.querySelector('[data-header-drawer]');
        this.megaToggle = this.querySelector('[data-header-mega-toggle]');
        this.mega = this.querySelector('[data-header-mega]');
        this.dropToggle = this.querySelector('[data-header-drop-toggle]');
        this.drop = this.querySelector('[data-header-drop]');

        this.setHeight();
        window.addEventListener('resize', () => this.setHeight());

        if (this.burger && this.drawer) {
          this.burger.addEventListener('click', () => this.toggleDrawer());
        }

        if (this.megaToggle && this.mega) {
          this.megaToggle.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleMega();
          });
          document.addEventListener('click', (event) => {
            if (!this.mega.hidden && !this.contains(event.target)) this.closeMega();
          });
        }

        if (this.dropToggle && this.drop) {
          this.dropToggle.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleDrop();
          });
          document.addEventListener('click', (event) => {
            if (!this.drop.hidden && !this.contains(event.target)) this.closeDrop();
          });
        }

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeMega();
            this.closeDrop();
            this.closeDrawer();
          }
        });

        window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
          if (event.matches) this.closeDrawer();
          else {
            this.closeMega();
            this.closeDrop();
          }
        });
      }

      setHeight() {
        if (!this.bar) return;
        document.documentElement.style.setProperty('--header-height', this.bar.offsetHeight + 'px');
      }

      toggleDrawer() {
        if (this.drawer.hidden) this.openDrawer();
        else this.closeDrawer();
      }

      openDrawer() {
        this.closeMega();
        this.closeDrop();
        this.setHeight();
        this.drawer.hidden = false;
        this.burger.setAttribute('aria-expanded', 'true');
        this.burger.classList.add('site-header__burger--on');
        document.documentElement.classList.add('site-header-drawer-open');
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.hidden = true;
        this.burger.setAttribute('aria-expanded', 'false');
        this.burger.classList.remove('site-header__burger--on');
        document.documentElement.classList.remove('site-header-drawer-open');
      }

      toggleMega() {
        if (this.mega.hidden) this.openMega();
        else this.closeMega();
      }

      openMega() {
        this.closeDrop();
        this.mega.hidden = false;
        this.megaToggle.setAttribute('aria-expanded', 'true');
        this.megaToggle.classList.add('site-header__nav-button--open');
      }

      closeMega() {
        if (!this.mega || this.mega.hidden) return;
        this.mega.hidden = true;
        this.megaToggle.setAttribute('aria-expanded', 'false');
        this.megaToggle.classList.remove('site-header__nav-button--open');
      }

      toggleDrop() {
        if (this.drop.hidden) this.openDrop();
        else this.closeDrop();
      }

      openDrop() {
        this.closeMega();
        this.drop.hidden = false;
        this.dropToggle.setAttribute('aria-expanded', 'true');
        this.dropToggle.classList.add('site-header__nav-button--open');
      }

      closeDrop() {
        if (!this.drop || this.drop.hidden) return;
        this.drop.hidden = true;
        this.dropToggle.setAttribute('aria-expanded', 'false');
        this.dropToggle.classList.remove('site-header__nav-button--open');
      }
    }
  );
}